<template>
  <div class="main-content jadwaldokter">
    <!-- <section class="inner-header about-us">
      	<div class="container pt-60 pb-70">
	        <div class="section-content">
	          	<div class="row">
	            	<div class="col-md-12">
	              		<h2 class="title">Jadwal Dokter</h2>
	            	</div>
	          	</div>
	        </div>
      	</div>
    </section>-->
    <section class="fasilitas-containter">
      <div class="container">
        <!-- <div class="section-title text-center">
		      	<div class="row">
		        	<div class="col-md-12">
		          		<h2 class="text-uppercase mt-0 line-height-1">Jadwal Dokter <span class="text-theme-colored">Rumah Sakit UII</span></h2>
		          		<p>Jl. Srandakan No.KM 5,5, Gedongsari, Wijirejo, Kec. Pandak, Bantul, Daerah Istimewa Yogyakarta 55761</p>
		        	</div>
		      	</div>
        </div>-->
        <div class="section-content mt-30" data-aos="fade-left" data-aos-delay="300">
          <iframe
            :src="jadwal_url"
            frameborder="0"
            border="0"
            cellspacing="0"
            style="border-style: none; width: 100%; min-height: 700px; max-height: 700px;"
          ></iframe>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { TERRA_JADWAL } from "../config/VariableComponents";
export default {
  data() {
    return {
      jadwal_url: TERRA_JADWAL,
      show_loading: true,
      data: {},
      user_data: {},
    };
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    checkUser() {
      let getUserData = localStorage.getItem("user_data");
      if (getUserData != undefined) {
        this.logged = true;
        this.user_data = JSON.parse(getUserData);

        if (this.user_data.rm != null)
          this.jadwal_url = this.jadwal_url + "?norm=" + this.user_data.rm;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/JadwalDokter.vue